import React from 'react';

const topics = [
  'Klinik Hipnoterapi',
  'ZeroMind',
  'LakuKeras.id',
  'InfoSecGuru',
  'Lainnya',
];

function ContactForm() {
  function handleSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const fields = new FormData(form);
    if (fields.get('website')) return;

    const message = [
      'Halo candradimuka.id cibubur, saya ingin menghubungi Anda.',
      '',
      `Nama: ${fields.get('name')}`,
      `Email: ${fields.get('email')}`,
      `Nomor WhatsApp: ${fields.get('phone') || '-'}`,
      `Topik: ${fields.get('topic')}`,
      '',
      'Pesan:',
      fields.get('message'),
    ].join('\n');

    const whatsappUrl = `https://wa.me/6281264656688?text=${encodeURIComponent(message)}`;
    window.location.assign(whatsappUrl);
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <label>
          Nama
          <input name="name" type="text" autoComplete="name" minLength="2" maxLength="80" required />
        </label>
        <label>
          Email
          <input name="email" type="email" autoComplete="email" required />
        </label>
      </div>
      <div className="form-row">
        <label>
          Nomor WhatsApp <span className="optional">(opsional)</span>
          <input name="phone" type="tel" autoComplete="tel" pattern="[0-9+() -]*" />
        </label>
        <label>
          Topik
          <select name="topic" defaultValue="" required>
            <option value="" disabled>Pilih topik</option>
            {topics.map((topic) => <option key={topic}>{topic}</option>)}
          </select>
        </label>
      </div>
      <label>
        Pesan
        <textarea name="message" minLength="10" maxLength="1000" rows="5" required />
      </label>
      <label className="honeypot" aria-hidden="true">
        Jangan isi kolom ini
        <input name="website" tabIndex="-1" autoComplete="off" />
      </label>
      <button className="button button-primary submit-button" type="submit">
        Lanjutkan ke WhatsApp <span aria-hidden="true">↗</span>
      </button>
      <p className="form-privacy">
        WhatsApp akan terbuka dengan pesan yang sudah disiapkan. Tekan Kirim di WhatsApp untuk mengirimnya.
      </p>
      <p className="form-status" aria-live="polite" />
    </form>
  );
}

export default ContactForm;